var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.15 13.1V5.074l1.545 1.545a.9.9 0 1 0 1.272-1.273l-3.08-3.08a.9.9 0 0 0-1.538.638V13.1a.9.9 0 1 0 1.8 0M5.75 2.004a.9.9 0 0 0-.9.9v8.026L3.304 9.386a.9.9 0 1 0-1.273 1.273l3.08 3.08a.9.9 0 0 0 1.537-.632V2.904a.9.9 0 0 0-.9-.9",
    clipRule: "evenodd"
  })));
};
export { SvgSort as ReactComponent };